import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=4f2110ec&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=ts"
export * from "./AdminReports.vue?vue&type=script&lang=ts"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=4f2110ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2110ec",
  null
  
)

export default component.exports